<template>
  <label
    v-if="label || mandatory || htmlLabel"
    v-bind="labelProps"
  >
    <!-- eslint-disable vue/no-v-html -->
    <span
      v-if="htmlLabel"
      v-html="htmlLabel"
    />
    <!-- eslint-enable vue/no-v-html -->
    <template v-else>
      {{ label }}
    </template>
    <span
      v-if="mandatory"
      class="label-fi__mandatory"
      >*</span
    >
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue';

defineOptions({
  name: 'LabelFi',
});

const props = withDefaults(
  defineProps<{
    label?: string | null | undefined;
    htmlLabel?: string | null | undefined;
    mandatory?: boolean | string;
    for?: string;
    limit80?: boolean | string;
    noEllipsis?: boolean;
  }>(),
  {
    label: undefined,
    htmlLabel: undefined,
    mandatory: false,
    for: undefined,
    limit80: false,
  },
);

const labelProps = computed(() => ({
  class: {
    'label-fi': true,
    preferNonApp: true,
    'label-fi--80': props.limit80,
    'label-fi--no-ellipsis': props.noEllipsis,
  },
  for: props.for,
}));
</script>

<style src="./label-fi-unscoped" />

<style scoped src="./label-fi" />
